// перевести рубли в копейки
export default function rublesToPenny(value) {
  //return parseInt((value * 100).toFixed(0));
  return Math.round(parseFloat(value) * 100.0).toFixed(0);
}
